import { OPERACAO_API_URL, CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProdutoFabricanteHistoricoEnvioEntity } from '@catalogo/models';

@Injectable({ providedIn: 'root' })
export class ProdutoFabricanteHistoricoEnvioDataService extends CrudService<ProdutoFabricanteHistoricoEnvioEntity> {
    protected url: string;
    urlOriginal: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/Produto/Fabricante/<id>/HistoricoEnvio`;
    }

    public withParentId(parentId: string) {
        this.url = this.urlOriginal.replace('<id>', parentId);
        return this;
    }
}
